import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'article', 'section', 'header', 'footer', 'div',
  'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'caption',
  'sup', 'sub', 'ol', 'ul', 'li',
  'a', 'strong', 'b', 'em', 'i', 'u', 'br', 'hr',
  'blockquote', 'span', 'small',
];

const ALLOWED_ATTR = ['id', 'href', 'name', 'colspan', 'rowspan', 'class', 'title', 'target', 'rel'];

export function sanitizeHtml(input: string): string {
  // Extrae el body si viene una página completa, para descartar headers/scripts del sitio.
  const bodyMatch = input.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  const fragment = bodyMatch ? bodyMatch[1] : input;

  return DOMPurify.sanitize(fragment, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button', 'noscript', 'meta', 'link'],
    KEEP_CONTENT: true,
    ALLOW_DATA_ATTR: false,
  });
}
